import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from "../../../node_modules/@mui/system/index";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatisSasb = () => {
  const urlConfig = {
    name: "Sasb.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/SASBStandards.zip",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="SASB"
            title={"SASB Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Box
        sx={{
          borderRadius: "8px",
          padding: "24px",
          top: "226px",
          left: "75px",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography
            component="h4"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 800,
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "-2%",
              color: "#4F4F4F",
              mb: 1,
            }}
          >
            What is SASB? — Brief introduction
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "-2%",
              color: "#4F4F4F",
            }}
          >
            The Sustainability Accounting Standards Board (SASB) is an
            independent standards-setting organization that develops
            industry-specific standards to guide companies in disclosing
            financially material sustainability information. SASB standards help
            organizations identify, manage, and report on ESG factors that are
            most relevant to financial performance and investor decision-making.
            Covering 77 industries, SASB provides a clear framework for
            consistent, comparable, and decision-useful sustainability
            reporting, aligning corporate transparency with capital market
            needs. In 2021, SASB merged under the Value Reporting Foundation,
            which is now part of the IFRS Foundation’s International
            Sustainability Standards Board (ISSB), advancing global ESG
            disclosure harmonization.{" "}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* <CustomButton title="Access Full SASB Standards Documentation"
                    route="/reporting/whatisgri"
                /> */}

        {/* <a
          href="https://sasb.ifrs.org/standards/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <CustomButton title="Access Full SASB Standards Documentation" />
        </a> */}

        <Box>
          <DownloadZipButton
            config={urlConfig}
            title="Access Full SASB Standards Documentation"
            externalHref="https://sasb.ifrs.org/standards/"
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default WhatisSasb;
